import React from 'react';
import { Wrap, WrapItem, Tag, Text } from '@chakra-ui/react';

const ScopeChips = ({ scopes, emptyLabel }) => {
  if (!scopes?.length) {
    return (
      <Text fontSize="sm" color="text.muted" fontStyle="italic">
        {emptyLabel}
      </Text>
    );
  }
  return (
    <Wrap spacing={2} mt={2}>
      {scopes.map(scope => (
        <WrapItem key={scope}>
          <Tag
            size="md"
            bg="gray.50"
            border="1px solid"
            borderColor="gray.200"
            color="text.primary"
            fontFamily="ui-monospace, SFMono-Regular, Menlo, monospace"
            fontSize="xs"
            fontWeight="500"
            px={2.5}
            py={1}
            borderRadius="md"
          >
            {scope}
          </Tag>
        </WrapItem>
      ))}
    </Wrap>
  );
};

export default ScopeChips;
